"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var initial = { content: null };
function useModal() {
    var _a = react_1.useState(initial), modal = _a[0], setModal = _a[1];
    var open = modal.content !== null;
    var onClose = function () { return setModal(initial); };
    var CurrentModal = function (_a) {
        var className = _a.className;
        return react_1.default.createElement(storybook_1.Modals.Modal, { open: open, onClose: onClose },
            react_1.default.createElement(storybook_1.Modals.Container, { className: className },
                react_1.default.createElement(storybook_1.Modals.Body, null,
                    react_1.default.createElement(storybook_1.Buttons.Button, { className: 'model-close-btn', onClick: onClose },
                        react_1.default.createElement(storybook_1.Icons.Icon, { name: 'x', className: 'storybook-icons-icon' })),
                    open && modal.content())));
    };
    return [CurrentModal, setModal, onClose];
}
exports.default = useModal;
